export const MinesEventTypes = {
  GameCheckout: "minesgamecheckout",
  StartGame: "minesstartgame",
  BombExploded: "minesbombexploded",
  RequestFlip: "minesrequestflip",
};
